<template>
  <section id="reset-password">
    <SACSetPassword
      v-if="!techSuccess"
      infoText="Create new password"
      buttonLabel="Reset Password"
      :processing="processing"
      :createPassword="createPassword"
      :error="error"
      :success="success"
    />
    <div
      v-else-if="techSuccess"
      class="success-container"
    >
      {{ techSuccess }}
      <a href="com.smac.pro://">
        Login to Pro app
      </a>
    </div>
  </section>
</template>

<script>
import axios from 'axios';

import SACSetPassword from '../components/sac/SACSetPassword.vue';

export default {
  name: 'ResetPasswordView',
  components: {
    SACSetPassword,
  },
  metaInfo: {
    title: 'SmartAC.com | Reset Password',
  },
  data() {
    return {
      processing: false,
      error: '',
      success: '',
      techSuccess: '',
    };
  },
  mounted() {
    const techRequested = this.$route.query.tech;
    if (techRequested) {
      const { token } = this.$route.params;
      try {
        const decoded = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
        const { exp } = decoded;
        if (Date.now() > exp) {
          this.$router.replace('/expired-link/reset');
        }
      } catch (error) {
        this.$router.replace('/expired-link/reset');
      }
    }
  },
  methods: {
    async createPassword(password) {
      try {
        const techRequested = this.$route.query.tech;
        this.processing = true;
        if (techRequested) {
          await axios({
            method: 'PUT',
            url: `${process.env.API_URL}/auth/technician/reset-password`,
            data: {
              password,
              token: this.$route.params.token,
            },
          });
          this.techSuccess = 'Password updated successfully. You can login to SmartAC.com Pro using your new password.';
        } else {
          await axios({
            method: 'PUT',
            url: `${process.env.API_URL}/auth/admin/reset-password`,
            data: {
              password,
              token: this.$route.params.token,
            },
          });
          this.success = 'Password updated successfully. Redirecting to login page...';
          setTimeout(() => {
            this.$store.dispatch('showSuccessToast', {
              message: 'Your password has been successfully updated',
            });
            this.$router.replace('/login-email');
          }, 2000);
        }
      } catch (err) {
        if (err.response) {
          const {
            data,
          } = err.response;
          if (data) {
            const {
              message,
            } = data;
            this.error = message;
          }
        } else {
          this.error = 'Token has expired or user does not exist';
        }
      }
      this.processing = false;
    },
  },
};
</script>

<style lang="scss">

section#reset-password {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: $WHITE;
  .success-container {
    width: 450px;
    height: 200px;
    background-color: $BASIL100;
    color: $WHITE;
    padding: 2rem;
    box-shadow: 0 1px 10px 0 rgb(9 15 32 / 10%);
    border-radius: 12px;
    font-size: 1.125rem;
    font-weight: 500;
    text-align: center;
    @media (max-width: 420px) {
      width: 300px;
      font-size: 1rem;
    }
  }
}
</style>
